module.exports = __webpack_public_path__ + "static/media/spotSelection.612110a2.svg";